// extracted by mini-css-extract-plugin
export default {"imagesContainer":"BeforeAfterImages_imagesContainer__NHr0C","imageContainer":"BeforeAfterImages_imageContainer__3jBHz","imageLabel":"BeforeAfterImages_imageLabel__V-zSb"};